'use client';

import React from 'react';
import { useRouter } from 'next/navigation';

type GetAccessOptionsProps = {
	onSelect?: () => void;
};

// The parent / provider choice shared by the Get Access modal and the mobile sign-up panel.
export default function GetAccessOptions({ onSelect }: GetAccessOptionsProps) {
	const router = useRouter();

	const go = (href: string) => {
		onSelect?.();
		router.push(href);
	};

	return (
		<div className="get-access-options">
			<div className="get-access-options__option">
				<button className="Button solid dark small reverse outline" onClick={() => go('/sign-up')}>
					I&apos;m a Parent
				</button>
				<p className="get-access-options__desc possums large-paragraph">Access The Possums Programs</p>
			</div>
			<div className="get-access-options__option">
				<button
					className="Button solid ndc-dark small reverse outline"
					onClick={() => go('/ndc-institute/sign-up')}
				>
					I&apos;m a Provider
				</button>
				<p className="get-access-options__desc large-paragraph">Upskill with courses at The NDC Institute</p>
			</div>
		</div>
	);
}
